/**
 * SilviaLoader — branded loading component
 * Variants: "screen" (fullscreen), "inline" (within page content)
 */

import silviaPng from '../assets/_silvia_white.png';
import './SilviaLoader.css';

interface SilviaLoaderProps {
  text?: string;
  variant?: 'screen' | 'inline';
}

export function SilviaLoader({ text = 'Ładowanie...', variant = 'inline' }: SilviaLoaderProps) {
  if (variant === 'screen') {
    return (
      <div className="silvia-loader-screen">
        <div className="silvia-loader-brand">
          <img src={silviaPng} alt="Silvia" className="silvia-loader-logo" />
          <span className="silvia-loader-name">Silvia</span>
        </div>
        <div className="silvia-loader-spinner">
          <svg viewBox="0 0 50 50" className="silvia-spinner-svg">
            <circle cx="25" cy="25" r="20" className="silvia-spinner-track" />
            <circle cx="25" cy="25" r="20" className="silvia-spinner-fill" />
          </svg>
        </div>
        <span className="silvia-loader-text">{text}</span>
      </div>
    );
  }

  return (
    <div className="silvia-loader-inline">
      <div className="silvia-loader-spinner">
        <svg viewBox="0 0 50 50" className="silvia-spinner-svg">
          <circle cx="25" cy="25" r="20" className="silvia-spinner-track" />
          <circle cx="25" cy="25" r="20" className="silvia-spinner-fill" />
        </svg>
      </div>
      <span className="silvia-loader-text">{text}</span>
    </div>
  );
}
